import React from "react";

import { Stack, StackProps } from "./Stack";

export const Center = React.forwardRef<
  React.ElementRef<typeof Stack>,
  StackProps
>(function Center(props, ref) {
  return (
    <Stack
      ref={ref}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      {...props}
    />
  );
});
